<template>
  <div class="content">
    <div class="ident-cells">
      <div class="container">
        <div class="ident-panel">
          <div class="ident-inner">
            <div class="ident-row">
              <div class="bd">
                <van-radio-group v-model="radio" :disabled="radioDisabled">
                  <van-radio name="1">个人认证</van-radio>
                  <van-radio name="2">企业认证</van-radio>
                </van-radio-group>
              </div>
            </div>
            <div class="ident-row hidden" :class="radio==1 || radio==0?'show':''">
              <div class="hd">
                <span class="text-danger">*</span>身份证照片
              </div>
              <div class="bd">
                <div class="photo-cell">
                  <div class="photo-box">
                    <van-uploader :after-read="onRead">
                      <van-icon name="plus"/>
                      <img class="photo-img" src="../assets/images/box.png" ref="goodsImg">
                    </van-uploader>
                  </div>
                  <div class="text">身份证正面</div>
                </div>
                <div class="photo-cell">
                  <div class="photo-box">
                    <van-uploader :after-read="onRead2">
                      <van-icon name="plus"/>
                      <img class="photo-img" src="../assets/images/box.png" ref="goodsImg2">
                    </van-uploader>
                  </div>
                  <div class="text">身份证反面</div>
                </div>
              </div>
            </div>
            <div class="ident-row hidden" :class="radio==2?'show':''">
              <div class="hd">
                <span class="text-danger">*</span>营业执照
              </div>
              <div class="bd">
                <div class="photo-cell">
                  <div class="photo-box">
                    <van-uploader :after-read="onRead3">
                      <van-icon name="plus"/>
                      <img class="photo-img" src="../assets/images/box.png" ref="goodsImg3">
                    </van-uploader>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="radio==2">
              <div class="ident-space">特殊行业要求</div>
              <div class="ident-row">
                <div class="hd">金融许可证</div>
                <div class="bd">
                  <div class="photo-cell">
                    <div class="photo-box">
                      <van-uploader :after-read="onRead4">
                        <van-icon name="plus"/>
                        <img class="photo-img" src="../assets/images/box.png" ref="goodsImg4">
                      </van-uploader>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ident-row">
                <div class="hd">网文许可证</div>
                <div class="bd">
                  <div class="photo-cell">
                    <div class="photo-box">
                      <van-uploader :after-read="onRead5">
                        <van-icon name="plus"/>
                        <img class="photo-img" src="../assets/images/box.png" ref="goodsImg5">
                      </van-uploader>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ident-group">
              <button v-if="!isSaveOpt" class="btn btn-primary" @click="caUpdate">更新</button>
              <button v-if="isSaveOpt" class="btn btn-primary" @click="commit">提交</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self;
export default {
  name: "Identify",
  mounted() {
    self = this;
    this.$nextTick(function() {
      self.getAccount(function(data) {
        self.account = data;
        self.radio = data.type==1||data.type==0?"1":"2"
        self.getCAInfo();
      });
    });
  },
  data() {
    return {
      radio: "1",
      account: null,
      idCardUpFile: null,
      idCardDownFile: null,
      companyLicenseFile: null,
      financeLicenseFile: null,
      networkCultureLicenseFile: null,
      isSaveOpt: true,
      radioDisabled: false
    };
  },
  methods: {
    onRead(file) {
      console.log(file);
      this.$refs.goodsImg.src = file.content;
      this.idCardUpFile = file;
    },
    onRead2(file) {
      console.log(file);
      this.$refs.goodsImg2.src = file.content;
      this.idCardDownFile = file;
    },
    onRead3(file) {
      console.log(file);
      this.$refs.goodsImg3.src = file.content;
      this.companyLicenseFile = file;
    },
    onRead4(file) {
      console.log(file);
      this.$refs.goodsImg4.src = file.content;
      this.financeLicenseFile = file;
    },
    onRead5(file) {
      console.log(file);
      this.$refs.goodsImg5.src = file.content;
      this.networkCultureLicenseFile = file;
    },
    commit: function() {
      var formData = new FormData();
      if (this.idCardUpFile != null) {
        formData.append("idCardUpFile", this.idCardUpFile.file);
      }
      if (this.idCardDownFile != null) {
        formData.append("idCardDownFile", this.idCardDownFile.file);
      }
      if (this.companyLicenseFile != null) {
        formData.append("companyLicenseFile", this.companyLicenseFile.file);
      }
      if (this.financeLicenseFile != null) {
        formData.append("financeLicenseFile", this.financeLicenseFile.file);
      }
      if (this.networkCultureLicenseFile != null) {
        formData.append(
          "networkCultureLicenseFile",
          this.networkCultureLicenseFile.file
        );
      }
      formData.append("authToken", this.getToken());
      formData.append("type", this.radio);
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/certification", formData)
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            window.layer.msg("提交成功");
          });
        });
    },
    caUpdate: function() {
      var formData = new FormData();
      if (this.idCardUpFile != null) {
        formData.append("idCardUpFile", this.idCardUpFile.file);
      }
      if (this.idCardDownFile != null) {
        formData.append("idCardDownFile", this.idCardUpFile.file);
      }
      if (this.companyLicenseFile != null) {
        formData.append("companyLicenseFile", this.companyLicenseFile.file);
      }
      if (this.financeLicenseFile != null) {
        formData.append("financeLicenseFile", this.financeLicenseFile.file);
      }
      if (this.networkCultureLicenseFile != null) {
        formData.append(
          "networkCultureLicenseFile",
          this.networkCultureLicenseFile.file
        );
      }
      formData.append("authToken", this.getToken());
      formData.append("type", this.radio);
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/certification/update", formData)
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            if(data){
              window.layer.msg("更新成功")
            }else{
              window.layer.msg("更新失败")
            }
          });
        });
    },
    getCAInfo: function() {
      var params = {};
      params["authToken"] = this.getToken();
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/certification/info", params)
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            if (data == null) {
              return;
            }
            self.radio=self.account.type==1||self.account.type==0?"1":"2"
            self.isSaveOpt = !self.isSaveOpt;
            if (self.account.type == 1) {
              var idCardUpUrl=data.idCardUpUrl
              if(idCardUpUrl!=null&&idCardUpUrl!=undefined){
                self.$refs.goodsImg.src = idCardUpUrl
              }
              var idCardDownUrl=data.idCardDownUrl
              if(idCardDownUrl!=null&&idCardDownUrl!=undefined){
                self.$refs.goodsImg2.src = idCardDownUrl
              }
            }
            if (self.account.type == 2) {
              var companyLicenseUrl=data.companyLicenseUrl
              if(companyLicenseUrl!=null&&companyLicenseUrl!=undefined){
                self.$refs.goodsImg3.src = companyLicenseUrl
              }
              var financeLicenseUrl=data.financeLicenseUrl
              if(financeLicenseUrl!=null&&financeLicenseUrl!=undefined){
                self.$refs.goodsImg4.src = financeLicenseUrl
              }

              var networkCultureLicenseUrl=data.networkCultureLicenseUrl
              if(networkCultureLicenseUrl!=null&&networkCultureLicenseUrl!=undefined){
                self.$refs.goodsImg5.src = networkCultureLicenseUrl
              }
              
            }
            self.radioDisabled = true;
          });
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Identify.vue